import { useAtomValue } from 'jotai';

import { useCanProviderUseTranscription } from '../../provider/session-recording/useCanProviderUseTranscriptionCallback';
import {
  AudioRecordingState,
  cloudRecordingStatusAtom,
  isCloudRecordingActive,
  participantCountAtom,
  recordingStateAtom,
} from '../../video-sdk';

export function useRecordingControl(hasAppointment: boolean = false) {
  const recordingState = useAtomValue(recordingStateAtom).value;
  const cloudStatus = useAtomValue(cloudRecordingStatusAtom);
  const syncMapSaysRecording = recordingState === AudioRecordingState.RECORDING;
  const isRecording = cloudStatus !== null ? isCloudRecordingActive(cloudStatus) : syncMapSaysRecording;
  const inSession = !!useAtomValue(participantCountAtom);
  const canProviderUseTranscription = useCanProviderUseTranscription();
  const isVisible = (inSession && hasAppointment && canProviderUseTranscription) || isRecording;

  return {
    isVisible,
    isRecording,
    recordingState,
  };
}
